const networkProviders = require('../helpers/network-providers');

const walletUrl = networkProviders.walletUrl;

module.exports = {
    walletUrl,
    walletUrlAccountSend: walletUrl + '/#/account/send',
    explorerUrl: networkProviders.explorerUrl
};
